import React, { useEffect } from "react";
import { useDashboardStore } from "../../../store/dashboardStore.js";
import { Select } from "antd";
import { PieChart } from "@mui/x-charts/PieChart";

import PrimaryButton from "../../button/primarybutton";


import Advancedreportschart from "./advancedreportschart";

import Loader from "../../loader/loader";

import images from "../../../assets";

export default function AdvancedReports() {
  const { userStats, isUserStatsLoading, getUserStats } = useDashboardStore();

  useEffect(() => {
    fetchUserStats();
  }, []);

  const fetchUserStats = async () => {
    getUserStats();
  };

  return (
    <>
      <div className="bg-[#f3f3fa] w-full py-8 flex-col justify-start items-end gap-4 flex">
        <div className="justify-start items-center gap-4 flex">
          <div className="rounded-lg border justify-between items-center flex">
            <Select
              showSearch
              style={{ width: 160, height: "40px" }}
              placeholder="Select Package"
              filterOption={(input, option) =>
                (option?.label ?? "")
                  .toLowerCase()
                  .includes(input.toLowerCase())
              }
              options={[
                {
                  value: "1",
                  label: "Lifetime",
                },
                {
                  value: "2",
                  label: "Basic",
                },
              ]}
            />
          </div>
          <PrimaryButton
            style={{
              height: "40px",
              width: "194px",
              fontSize: "16px",
              fontWeight: 500,
            }}
            text={"Advanced Filter"}
            iconalign="left"
            icon={images.advanceFilterIcon}
          />
        </div>
        {isUserStatsLoading ? (
          <Loader />
        ) : (
          <div className="w-full justify-center gap-5 flex">
            <Advancedreportschart
              title="Total User"
              usericon={images.userIcon}
              userbg="#bfb0c6"
              totaluser={userStats?.count?.toLocaleString() ?? 0}
              maletitle={`Male (${
                userStats?.totalMaleUsers?.toLocaleString() ?? 0
              })`}
              malecolor="#009efa"
              femaletitle={`Female (${
                userStats?.totalFemaleUsers?.toLocaleString() ?? 0
              })`}
              femalecolor="#fa49a5"
              malepercentage={
                userStats?.totalMaleUsersPercentage?.toLocaleString() ?? 0
              }
              femalemalepercentage={
                userStats?.totalFemaleUsersPercentage?.toLocaleString() ?? 0
              }
              historyicon={images.historyIcon}
              historypercentage="1.5%"
              historypercentagecolor="#f31260"
              historytitle="less from yesterday"
            >
              <PieChart
                series={[
                  {
                    data: [
                      {
                        label: "Male",
                        value: userStats?.totalMaleUsers,
                        color: "#009efa",
                      },
                      {
                        label: "Female",
                        value: userStats?.totalFemaleUsers,
                        color: "#fa49a5",
                      },
                    ],
                    cx: 145,
                    innerRadius: 60,
                    outerRadius: 100,
                  },
                ]}
                height={300}
                width={300}
                slotProps={{
                  legend: { hidden: true },
                }}
              />
            </Advancedreportschart>
            <Advancedreportschart
              title="Membership"
              usericon={images.membershipIcon}
              userbg="#fce3bb"
              totaluser={userStats?.count?.toLocaleString() ?? 0}
              maletitle={`Premium (${
                userStats?.totalPremiumUsers?.toLocaleString() ?? 0
              })`}
              malecolor="#ff8f42"
              femaletitle={`Basic (${
                userStats?.totalBasicUsers?.toLocaleString() ?? 0
              })`}
              femalecolor="#505f79"
              malepercentage={
                userStats?.totalPremiumUsersPercentage?.toLocaleString() ?? 0
              }
              femalemalepercentage={
                userStats?.totalBasicUsersPercentage?.toLocaleString() ?? 0
              }
              historyicon={images.historyIcon2}
              historypercentage="2.5%"
              historypercentagecolor="#17c964"
              historytitle="more from yesterday"
            >
              <PieChart
                series={[
                  {
                    data: [
                      {
                        label: "Premium",
                        value: userStats?.totalPremiumUsers,
                        color: "#ff8f42",
                      },
                      {
                        label: "Basic",
                        value: userStats?.totalBasicUsers,
                        color: "#505f79",
                      },
                    ],

                    cx: 145,
                    innerRadius: 60,
                    outerRadius: 100,
                  },
                ]}
                height={300}
                width={300}
                slotProps={{
                  legend: { hidden: true },
                }}
              />
            </Advancedreportschart>
            <Advancedreportschart
              title="Total Upgrade"
              usericon={images.cartIcon}
              userbg="#b7eecf"
              totaluser={userStats?.totalPremiumUsers?.toLocaleString() ?? 0}
              maletitle="Self (441)"
              malecolor="#108f47"
              femaletitle="Admin (24,427)"
              femalecolor="#c2c7d0"
              malepercentage="1.03"
              femalemalepercentage="98.97"
              historyicon={images.historyIcon2}
              historypercentage="1.3%"
              historypercentagecolor="#17c964"
              historytitle="less from yesterday"
            >
              <PieChart
                series={[
                  {
                    data: [
                      {
                        label: "Male",
                        value: userStats?.totalMaleUsers,
                        color: "#c2c7d0",
                      },
                      {
                        label: "Female",
                        value: userStats?.totalFemaleUsers,
                        color: "#108f47",
                      },
                    ],

                    cx: 145,
                    innerRadius: 60,
                    outerRadius: 100,
                  },
                ]}
                height={300}
                width={300}
                slotProps={{
                  legend: { hidden: true },
                }}
              />
            </Advancedreportschart>

            <div className="w-full self-stretch p-4 bg-white rounded-2xl flex-col justify-between items-center inline-flex">
              <div className="self-stretch justify-between items-start inline-flex">
                <div className="grow shrink basis-0 flex-col justify-start items-start gap-[13px] inline-flex">
                  <p className="opacity-70 text-[#222222]/60 text-base font-normal  leading-normal">
                    Register Type
                  </p>
                  <p className="text-[#222222] text-3xl font-semibold  leading-9">
                    {userStats?.count?.toLocaleString() ?? 0}
                  </p>
                </div>
                <div className="w-[60px] h-[60px] bg-[#f8e6ef] flex justify-center items-center rounded-3xl">
                  <img src={images.newUser} />
                </div>
              </div>
              <div className="w-full self-stretch flex-col justify-between items-center flex gap-4">
                <div className="relative w-[224px] flex-col justify-start items-center gap-4 flex">
                  {/* <Doughnut
                  data={{
                    datasets: [
                      {
                        label: "User",
                        data: [20, 2, 8, 3],
                        backgroundColor: [
                          "#0fadcf",
                          "#ba0060",
                          "#310048",
                          "#755484",
                        ],
                        borderColor: [
                          "#0fadcf",
                          "#ba0060",
                          "#310048",
                          "#755484",
                        ],
                        cutout: "60%",
                      },
                    ],
                  }}
                /> */}
                  <PieChart
                    series={[
                      {
                        data: [
                          { label: "Male", value: userStats?.totalMaleUsers },
                          { label: "Male", value: userStats?.totalMaleUsers },
                          { label: "Male", value: userStats?.totalMaleUsers },
                          {
                            label: "Female",
                            value: userStats?.totalFemaleUsers,
                          },
                        ],
                        cx: 145,
                        innerRadius: 60,
                        outerRadius: 100,
                      },
                    ]}
                    height={300}
                    width={300}
                    slotProps={{
                      legend: { hidden: true },
                    }}
                  />
                  <div className="top-[42%] absolute flex flex-col items-center">
                    <h3 className="text-basePrimary text-[22.24px] font-semibold  leading-[33.37px]">
                      {userStats?.count?.toLocaleString() ?? 0}
                    </h3>
                    <p className="text-[#222222]/60 text-[9.89px] font-normal  leading-[14.83px]">
                      Users
                    </p>
                  </div>
                </div>
                <div className="self-stretch justify-center items-start gap-8 inline-flex">
                  <div className="grow shrink basis-0 h-[116px] justify-between items-start flex">
                    <div className="flex-col justify-start items-start gap-3 inline-flex">
                      <div className="justify-start items-center gap-2 inline-flex">
                        <div className="w-3 h-3 bg-basePrimary rounded-full" />
                        <p className="text-[#222222] text-sm font-normal  leading-tight">
                          Home
                        </p>
                      </div>
                      <div className="justify-start items-center gap-2 inline-flex">
                        <div className="w-3 h-3 bg-[#bfb0c6] rounded-full" />
                        <p className="text-[#222222] text-sm font-normal  leading-tight">
                          Campaign
                        </p>
                      </div>
                      <div className="justify-start items-center gap-2 inline-flex">
                        <div className="w-3 h-3 bg-[#755484] rounded-full" />
                        <p className="text-[#222222] text-sm font-normal  leading-tight">
                          Blog
                        </p>
                      </div>
                      <div className="justify-start items-center gap-2 inline-flex">
                        <div className="w-3 h-3 bg-[#c2c7d0] rounded-full" />
                        <p className="text-[#222222] text-sm font-normal  leading-tight">
                          Affiliate
                        </p>
                      </div>
                    </div>
                    <div className="flex-col justify-start items-start gap-3 inline-flex text-[#222222]/60 text-sm font-normal  leading-tight">
                      <p>9,328</p>
                      <p>30</p>
                      <p>2,453</p>
                      <p>0</p>
                    </div>
                  </div>
                  <div className="grow shrink basis-0 h-[84px] justify-between items-start flex">
                    <div className="flex-col justify-start items-start gap-3 inline-flex">
                      <div className="justify-start items-center gap-2 inline-flex">
                        <div className="w-3 h-3 bg-[#0fadcf] rounded-full" />
                        <p className="text-[#222222] text-sm font-normal  leading-tight">
                          Android
                        </p>
                      </div>
                      <div className="justify-start items-center gap-2 inline-flex">
                        <div className="w-3 h-3 bg-[#8fd0ef] rounded-full" />
                        <p className="text-[#222222] text-sm font-normal  leading-tight">
                          iOS
                        </p>
                      </div>
                      <div className="justify-start items-center gap-2 inline-flex">
                        <div className="w-3 h-3 bg-secondary rounded-full" />
                        <p className="text-secondary text-sm font-normal  underline leading-tight">
                          Digital ADs
                        </p>
                      </div>
                    </div>
                    <div className="flex-col justify-start items-start gap-3 inline-flex text-[#222222]/60 text-sm font-normal  leading-tight">
                      <p>34,846</p>
                      <p>0</p>
                      <p>1,215</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
}








